import { Component } from '@angular/core';
import { NatureOperationId } from '@lib/models/graphqlData';
import { FicheConseil } from '@lib/models/generated/graphql';
import { ObjectifsService } from '@lib/services/objectifs.service';
import { AbstractStepComponent } from 'src/app/components/declare-fiche-conseil/steps/abstract-step.component';
import { FicheConseilService } from 'src/app/services/fiche-conseil.service';
import { FormConfigService } from 'src/app/services/form-config.service';
import { FieldFormControl } from 'src/fieldFormControl/FieldFormControl';

@Component({
  selector: 'app-precision-complementaire-step',
  templateUrl: './precision-complementaire-step.component.html',
  styleUrls: ['./precision-complementaire-step.component.scss'],
})
export class PrecisionComplementaireStepComponent extends AbstractStepComponent {
  controlAutre: FieldFormControl<string | null, string>;
  controlEnveloppe: FieldFormControl<string | null, string>;
  controlAllocation: FieldFormControl<string | null, string>;

  constructor(
    protected override ficheConseilService: FicheConseilService,
    protected formConfigService: FormConfigService,
    private objectifsService: ObjectifsService
  ) {
    super(ficheConseilService);
  }

  get shouldShowEnveloppeComment(): boolean {
    return ![
      NatureOperationId.ArbitrageLibre,
      NatureOperationId.ChangementModeGestion
    ].includes(this.currentFicheConseil?.natureOperation?.id as NatureOperationId);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.controlAutre = new FieldFormControl<string | null, string>({
      formConfigService: this.formConfigService,
      ficheConseilService: this.ficheConseilService,
      dataKey: 'precisionComplementaire.commentaireAutre',
      defaultValue: this.currentFicheConseil?.precisionComplementaire?.commentaireAutre ?? null,
    });
    this.controlEnveloppe = new FieldFormControl<string | null, string>({
      formConfigService: this.formConfigService,
      ficheConseilService: this.ficheConseilService,
      dataKey: 'precisionComplementaire.commentaireEnveloppe',
      defaultValue: this.currentFicheConseil?.precisionComplementaire?.commentaireEnveloppe ?? null,
    });

    this.controlAllocation = new FieldFormControl<string | null, string>({
      formConfigService: this.formConfigService,
      ficheConseilService: this.ficheConseilService,
      dataKey: 'precisionComplementaire.commentaireAllocation',
      defaultValue: this.currentFicheConseil?.precisionComplementaire?.commentaireAllocation ?? null,
    });
  }
  override beforeFicheConseilUpdate(newFicheConseil: FicheConseil | null, previousFicheConseil: FicheConseil | null) {
    //nothing to do
  }
  public override isStepValid(): boolean {
    return true;
  }
  public override markAsTouched(): void {
    //nothing to do
  }

  onPreview() {
    this.ficheConseilService.previewPDF();
  }
}
